export const excludedRoutes = ["/login", "/signup", "/", "/mail-otp"];
